export const ROLE = {
  SENTINEL_USERS: 'SENTINEL_USERS',
  SENTINEL_PROJECT_CREATION: 'SENTINEL_PROJECT_CREATION',
  SENTINEL_POWER_USER: 'SENTINEL_POWER_USER',
};
